// Desc: Admin Overview page
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import { httprequest } from "../../../data/api";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import TabContext from "@mui/lab/TabContext";
import { Icon } from "@iconify/react/dist/iconify.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { TableSearch } from "../../../components/Table/TableActions";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
import Modal from "../../../components/Modal";
import Badge from "../../../components/Badge";
import { useUserState } from "../../../context/UserContext";
import { Link } from "react-router-dom";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const CLASSES_ENDPOINT = "/api/v1/class";
const SCHOOL_TEST_RESULT = "/api/v1/ca-test/result/";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const TEACHER_SUBJECT = "/api/v1/teacher/class-subject/";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

const TestResult = () => {
//   const navigate = useNavigate();
  const { userRole } = useUserState();
  const [value, setValue] = useState("");
  const [caValue, setCAValue] = useState("");
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [itemModal, setItemModal] = useState(false);
  const [isClassLoading, setIsClassLoading] = useState(false);
  // const [getRowResultDetails, setGetRowResultDetails] = useState(false);
  const [isSubjectLoading, setSubjectIsLoading] = useState(false);
  const [allCAResults, setAllTestResults] = useState([]);
  const [testresultDetails, setTestResultsDetails] = useState([]);
  const [searchtestresultDetails, setSearchTestResultsDetails] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [getIsLoading, setGetIsLoading] = useState(false);
  const [obtainablescore, setObtainableScore] = useState([]);
  const width = useWindowSize();
  const isMobile = width < 600;

  /**
 * @file A collection of functions for managing school test results, terms, sessions, and related data.
 */

  /**
 * Boolean indicating if the current user is a teacher
 * @type {boolean}
 */
  const isTeacher = userRole?.role_type === "employee";
  /**
 * Fetches all terms for a given session and filters them by session ID.
 * @param {string} Session_ID - The ID of the session to filter terms by.
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
 * Handles opening of the item modal and sets the selected row data.
 * @param {Object} row - The row data to display in the modal.
 */
  const handleOpenItemMOdal = (row) => {
    setSelectedRow(row);
    setItemModal(!itemModal);
    setTestResultsDetails(row?.details);
    setSearchTestResultsDetails(row?.details);
  };

  /**
 * Handles closing of the result modal.
 */
  const handleCloseResult = () => {
    setItemModal(false);
  };

  /**
 * Fetches school test results for a specific class and term.
 * @param {string} class_id - The ID of the class.
 * @param {string} aselectedTerm - The ID of the selected term.
 */
  const getSchoolTestResult = (class_id, aselectedTerm) => {
    setGetIsLoading(true);
    httprequest
      .get(`${SCHOOL_TEST_RESULT}${class_id}?term_id=${aselectedTerm}`)
      .then((res) => {
        setAllTestResults(res?.data?.data);
        setSearchResult(res?.data?.data);
        setGetIsLoading(false);
      }).catch((err) => {
        setGetIsLoading(false);
        toast.error(err?.response?.message);
      });
  };

  /**
 * Fetches all available sessions and sets the active session.
 * @async
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Fetches all classes, either for a teacher or all classes based on the isTeacher flag.
 */
  const getAllClasses = () => {
    setIsClassLoading(true);
    const CLASS_ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : CLASSES_ENDPOINT;
    httprequest
      .get(CLASS_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data;
        setClassData(physicalClasses);
        setIsClassLoading(false);
      })
      .catch((err) => {
        setIsClassLoading(false);
        toast.error(err?.response?.data);
      });
  };

  /**
 * The currently active term in the current session.
 * @type {Object}
 */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session change events and fetches terms for the selected session.
 * @param {Event} e - The change event.
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
 * Handles term change events and fetches school test results for the selected term.
 * @param {Event} event - The change event.
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getSchoolTestResult(value, selectedTermId);
  };

  /**
 * Handles filter change events for subject selection.
 * @param {Event} e - The change event.
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter by subject name when filter is applied
    const filteredByStatus = value
      ? allCAResults?.filter(
        (data) => data?.subject?.name?.toLowerCase() === value.toLowerCase()
      )
      : allCAResults?.students;

    setSearchResult(filteredByStatus);
  };

  /**
 * Fetches all subjects for a specific class.
 * @async
 * @param {string} class_value - The ID of the class.
 */
  const getAllSubjectForClass = async (class_value) => {
    setSubjectIsLoading(true);
    try {
      const ENDPOINT = isTeacher ? TEACHER_SUBJECT : CLASS_SUBJECT;
      const res = await httprequest.get(`${ENDPOINT}${class_value}`);
      setAllClassSubject(res?.data?.data);
    } catch (err) {
      toast.error(err?.response?.data);
    } finally {
      setSubjectIsLoading(false);
    }
  };

  /**
 * Handles tab change events and fetches related data.
 * @param {Event} event - The change event.
 * @param {string} newValue - The new tab value.
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);
    getAllSubjectForClass(newValue);
    getSchoolTestResult(newValue, aselectedTerm);
  };

  /**
       * Fetches all obtainable scores from the API
       */
  const getAllObtainableScores = () => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.find((obtainable) => obtainable?.session?.id === activeSession?.id) || []);
        setCAValue(res?.data?.data?.find((obtainable) => obtainable?.session?.id === activeSession?.id)?.ca[0]?.ca_type);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Handles CA type change events.
 * @param {Event} event - The change event.
 * @param {string} newValue - The new CA value.
 */
  const handleCAChange = (event, newValue) => {
    setCAValue(newValue);
  };

  /**
 * Columns configuration for the CA Results table.
 * @type {Array<Object>}
 */
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Name</p>}
          {`${row?.student?.last_name || "--/--"} ${row?.student?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name}
        </>
      )
    },
    {
      name: "Subject",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    ...(
      Array.from(
        new Set(
          allCAResults?.flatMap(result => Object.keys(result?.ca_scores || {})
          )
        )
      ).map((caKey) => ({
        name: caKey,
        selector: (row) => (
          <>
            {isMobile && <p className="mobile-styling">{caKey}</p>}
            {row?.ca_scores?.[caKey] ?? "--/--"}
          </>
        )
      }))
    ),
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row, index) => (
        <div key={index} className="table-action-container">
          <button
            onClick={() => handleOpenItemMOdal(row)}
            className={"table-action-icon"}
          >
            <Icon icon="iconamoon:question-mark-circle" width="20" height="20" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Columns configuration for the test result details table.
 * @type {Array<Object>}
 */
  const testresultdetailscolumn = [
    {
      name: "Test Title",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Test Title</p>}
          {row?.title}
        </>
      )
    },
    {
      name: "TotalScore",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Score</p>}
          {row?.total_grade || "--/--"}
        </>
      )
    },
    {
      name: "Student Score",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Score</p>}
          {row?.student_score || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row.status?.toLowerCase()} />
    },
    {
      name: "View",
      center: true,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/ca-result-details/${row?.submission_id || row?.id}`} className="table-action-icon">
            <Icon icon="ph:arrow-right-bold" width="20" height="20" />
          </Link>
        </div>
      )
    }
  ];

  /**
 * Filters test result details table using title, status and category.
 * @param {Event} e - The input change event.
 */
  const handleSearchTestResult = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = testresultDetails?.filter((data) => valArray?.every(
      (word) => data?.title
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                      data?.status
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase()) ||
                                      data?.category
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase()) ||
                                        data?.status
                                          ?.toLowerCase()
                                          .includes(word.toLowerCase())
    )
    );
    setSearchTestResultsDetails(result);
  };

  /**
 * Filters student table using name and CA scores.
 * @param {Event} e - The input change event.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? allCAResults?.filter((data) => data?.subject?.name.toLowerCase() === value.toLowerCase()
      )
      : allCAResults;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.student?.last_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.subject?.name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.ca1
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.ca2
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * Effect hook that runs on component mount to fetch initial data.
 */
  useEffect(() => {
    getAllClasses();
    getAllSessions();
    getAllTerms();
  }, []);

  /**
 * Effect hook that sets the selected term when active term changes.
 */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
    }
  }, [active_term_session]);

  /**
 * Effect hook that fetches terms when active session changes.
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
      getAllObtainableScores();
    }
  }, [activeSession]);

  /**
 * Effect hook that sets default class and fetches related data when classes data is available.
 */
  useEffect(() => {
    if (classesData?.length > 0 && !value) {
      const defaultClassId = isTeacher ? classesData[0]?.class?.id : classesData[0]?.id;
      setValue(defaultClassId);
      getAllSubjectForClass(defaultClassId);
      getSchoolTestResult(defaultClassId, aselectedTerm);
    }
  }, [classesData]);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/assessment"
              link_one_name="CA Tests"
              active="CA Test Results"
              description="See all CA Results"
            />
          </div>
        </div>

        <div className="flex gap-10 align-items-end margin-top-5 margin-bottom padding-left-16">
          <div>
            {activeSession?.id && (
              <SelectGroup
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            {active_term_session?.id && (
              <SelectGroup
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select---</option>
                    {selectedSessionTerms?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.term}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            <SelectGroup
              children={
                <select onChange={handleFilterChange}>
                  <option value="">{isSubjectLoading ? "Please wait..." : "Subject"}</option>
                  {allClassSubject?.map((data) => {
                    return (
                      <option key={isTeacher ? data?.subject?.id : data?.subject_id} value={isTeacher ? data?.subject?.name : data?.subject_name}>
                        {isTeacher ? data?.subject?.name : data?.subject_name}
                      </option>
                    );
                  })}
                </select>
              }
            />
          </div>
        </div>

        <TabContext value={value}>
          <div className="tablist-container padding-left-16">
            {isClassLoading ? (
              <div className="container-left">
                <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
              </div>
            ) : (
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label="class tabs"
              >
                {classesData?.map((data) => {
                  return (
                    <Tab
                      key={isTeacher ? data?.class?.id : data?.id}
                      value={isTeacher ? data?.class?.id : data?.id}
                      label={isTeacher ? data?.class?.name : data?.class_name}
                    />
                  );
                })}
              </Tabs>
            )}
          </div>
          {classesData?.map((data) => {
            return (
              <TabPanel sx={{ padding: "0px !important" }} key={isTeacher ? data?.class?.id : data?.id} value={isTeacher ? data?.class?.id : data?.id}>
                <div className="page-content">
                  <>
                    {getIsLoading ? (
                      <PageLoader />
                    ) : (
                      <Table
                        data={searchResult}
                        columns={columns}
                        subHeader={true}
                        pagination
                        subHeaderComponent={
                          <div className="action_div">
                            <TableSearch
                              placeholder="Search here..."
                              searchTableFunc={handleSearchStudent}
                            />
                          </div>}
                      />
                    )}
                  </>
                </div>
              </TabPanel>
            );
          })}
        </TabContext>
        {/* View Log Option */}
        <Modal
          title={`${selectedRow?.subject?.name} CA Details`}
          subtitle={
            <div>
                You can view all the CA Results for this subject.
            </div>
          }
          modalContent={
            <>
              <div className="table-border">
                <h4 className="padding-left-16 no-margin-block">{`${selectedRow?.student?.last_name || "--/--"} ${selectedRow?.student?.first_name || "--/--"}`}</h4>
                <TabContext value={caValue}>
                  <div className="tablist-container padding-left-16">
                    <Tabs
                      className="overide-tablist"
                      onChange={handleCAChange}
                      aria-label=""
                    >
                      {obtainablescore?.ca?.map((ca, i) => (
                        <Tab key={i} value={ca?.ca_type} label={ca?.ca_type} />
                      ))}
                    </Tabs>
                  </div>

                  {obtainablescore?.ca?.map((ca, i) => {
                    const filteredData = searchtestresultDetails.filter((item) => item?.ca_type === ca?.ca_type);

                    return (
                      <TabPanel className="tabpanel-overide no_padding_0" key={i} value={ca?.ca_type}>
                        <Table
                          data={filteredData}
                          columns={testresultdetailscolumn}
                          subHeader={true}
                          pagination
                          subHeaderComponent={
                            <TableSearch
                              placeholder="Search here..."
                              searchTableFunc={handleSearchTestResult}
                            />
                          }
                        />
                      </TabPanel>
                    );
                  })}
                </TabContext>

              </div>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={itemModal}
          closeModal={handleCloseResult}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default TestResult;
